/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';

export interface PostConsigneeArticleNoteVisible$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
  articleKey: KeyType;
  articleNoteKey: KeyType;
}

export function postConsigneeArticleNoteVisible(http: HttpClient, rootUrl: string, params: PostConsigneeArticleNoteVisible$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postConsigneeArticleNoteVisible.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('articleKey', params.articleKey, {});
    rb.path('articleNoteKey', params.articleNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postConsigneeArticleNoteVisible.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/notes/{articleNoteKey}/visible';
